import styled from '@emotion/styled';
import FONT from '../../../styles/emotion/fonts';
import COLORS from '../../../styles/emotion/colors3';
import { TagContainer, TagContent } from '../TagV2.styles';

export const LetterpressTagWrapper = styled.div`
  ${TagContainer} {
    background-color: #55a1bf33;
    box-shadow: none;
    padding: 0 8px;
  }
  ${TagContent} {
    background-color: #0075ae;
    color: ${COLORS.COVE_100};
    -webkit-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    text-shadow: -0.5px 0.5px 1px rgba(255, 255, 255, 0.7);
    font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
    font-weight: ${FONT.FONT_WEIGHT_REGULAR};
    line-height: ${FONT.FONT_SIZE_REGULAR};
    text-shadow: none;
  }
`;
